import { Box, Tooltip, Typography } from "@husqvarna/ui-core";
import NavigationItem from "../NavigationItem/NavigationItem";
import { Link } from "react-router-dom";
import { ReactComponent as HusqvarnaLogo } from "../../../../shared/icons/husqvarna-logo.svg";
import { useDispatch } from "react-redux";
import { useIntl, defineMessage } from "react-intl";
import Project from "../../../../project/models/Project";
import { clearSelectedProject } from "../../../../project/projectSlice";
import { useCheckAuthQuery } from "../../../api/authApi";

/** format.js cli needs this to be able to extract translation for the SitebarItems */
defineMessage({
  id: 'header.navigation.projects.generalInfo',
  defaultMessage: 'General info'
})
defineMessage({
  id: 'header.navigation.projects.currentSetup',
  defaultMessage: 'Current setup'
})
defineMessage({
  id: 'header.navigation.projects.newSetup',
  defaultMessage: 'New setup'
})
defineMessage({
  id: 'header.navigation.projects.finance',
  defaultMessage: 'Pricing & Finance'
})
defineMessage({
  id: 'header.navigation.admin',
  defaultMessage: 'Admin'
})

type LeftNavigationProps = {
  selectedProject: Project | undefined;
};

const LeftNavigation = ({selectedProject} : LeftNavigationProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { data: user } = useCheckAuthQuery();

  const resetSelectedProject = () => {
    dispatch(clearSelectedProject());
  }

  return (
      <Box className="tcsp-header__left" alignItems="center">
        <Tooltip toolTipText="Home">
          <Link to="/projects" onClick={resetSelectedProject} className="tcsp-header__logo" >
            <HusqvarnaLogo height={60} width={60}/>
          </Link>
        </Tooltip>
        {selectedProject && (
          <Box className="tcsp-header__nav">
            <NavigationItem to={`/projects/${selectedProject.id}/new-setup`} i18nKey="header.navigation.projects.newSetup" />
            <NavigationItem to={`/projects/${selectedProject.id}/current-setup`} i18nKey="header.navigation.projects.currentSetup" />
            <NavigationItem to={`/projects/${selectedProject.id}/general-info`} i18nKey="header.navigation.projects.generalInfo" />
            <NavigationItem to={`/projects/${selectedProject.id}/finance`} i18nKey="header.navigation.projects.finance" />
          </Box>
        )}
        {!selectedProject && (
          <Box mx={6} flexDirection="row" gap={3} alignItems="center">
            <Typography variant="Body1" text={intl.formatMessage({id: "header.siteName", defaultMessage: "Turf Care Site Planner"})} />
            <Box backgroundColor="Grey100" px={2} py={1} alignContent="center" br={2} flexDirection="row" alignItems="center">
              <Typography variant="Button" color="HusqvarnaBlue100" text={intl.formatMessage({id: "header.badge", defaultMessage: "beta"})} />
            </Box>
            {user?.isAdmin && (
              <NavigationItem to="/admin" i18nKey="header.navigation.admin" defaultMessage="Admin" />
            )}
          </Box>
        )}
      </Box>
)}

export default LeftNavigation;